<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Jalan" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <Alert
            v-if="cancelSuccess"
            :alert="{
              title: 'Berhasil membatalkan pemeriksaan',
              type: 'success',
              content: `Pemeriksaan '${cancelItem.name}' berhasil dibatalkan dari sistem`,
            }"
          />
          <Alert
            v-if="cancelFailed"
            :alert="{
              title: 'Gagal membatalkan pemeriksaan',
              type: 'danger',
              content: `Terjadi kesalahan pada sistem. Pemeriksaan '${cancelItem.name}' gagal dibatalkan`,
            }"
          />
          <Alert
            v-if="doctorCallSuccess"
            :alert="{
              title: 'Pasien telah dipanggil',
              type: 'success',
              content: `Pasien '${doctorCallItem.name}' masuk dalam antrian dokter`,
            }"
          />
          <Alert
            v-if="doctorCallFailed"
            :alert="{
              title: 'Gagal memanggil pasien',
              type: 'danger',
              content: `Terjadi kesalahan pada sistem. Pasien '${doctorCallItem.name}' gagal dipanggil`,
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div>
            <div class="row mb-4">
              <div class="col-md-10 pt-3 pr-1">
                <!-- @include('blocks.tabs') -->
                <b-tabs pills>
                  <b-tab
                    v-for="item in tabs"
                    v-bind:key="item.title + String(Math.random(1023))"
                    :title="item.title"
                    @click="() => filterTab(item.filter)"
                    :active="item.filter == status"
                  />
                </b-tabs>
              </div>
              <div class="col-md-2 pl-1">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-body p-3">
                        <p class="mb-1">Lama Pelayanan</p>
                        <h5 class="text-primary mb-0">
                          {{ avgTime }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-filter-sort no-print mb-3">
            <div class="row">
              <div class="col-md-10">
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-2">
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="totalData > 10" value="25">25 data</option>
                      <option v-if="totalData > 25" value="50">50 data</option>
                      <option v-if="totalData > 50" value="100">
                        100 data
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <!-- :per-page="parseInt(perPage)"
            :filter="filter" -->
            <datatable
              v-if="loaded && rows.length"
              :columns="columns"
              :data="rows"
              class="table table-hover responsive"
            ></datatable>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{
                img: '/img/med.svg',
                size: 'small',
                title: `Tidak ada data rawat jalan dengan status '${status.toLowerCase()}' dan filter di atas`,
                content:
                  'Mulai pemeriksaan baru dengan mengeklik tombol + Rawat Jalan Baru di atas',
              }"
            />
            <Loading v-else />
            <!--             <br/>
            <p v-if="rows.length">Menampilkan {{rows.length>parseInt(perPage)?perPage:rows.length}} data dari total {{rows.length}} data</p>
<datatable-pager
              v-if="loaded && rows.length"
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
            ></datatable-pager> -->
            <br />
            <p v-if="totalData">
              Menampilkan {{ rows.length }} data dari total {{ totalData }} data
            </p>
            <b-pagination
              v-model="page"
              v-if="rows && rows.length"
              :total-rows="totalData"
              :per-page="parseInt(perPage)"
              v-on:click.native="(e) => goToPage(e)"
              align="center"
              first-number
              last-number
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="row.id + String(Math.random(1023))"
      :id="'cancel' + row.id"
      @click="
        () => {
          cancel(row.id, `${row.no_rawat} | ${row.no_rm} - ${row.pasien.nama}`);
        }
      "
      style="display: none"
    ></button>
    <button
      v-for="row in rows"
      v-bind:key="row.id + String(Math.random(1023))"
      :id="'doctorCall' + row.id"
      @click="
        () => {
          doctorCall(
            row.id,
            row.pasien.nama,
            row.no_rawat,
            row.no_rm,
            row.dokter.nama,
            row.formatted_no_antrian_dokter
          );
        }
      "
      style="display: none"
    ></button>
    <div class="modal modal-confirm" id="modalDelete" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/alert-triangle.svg"
              style="width: 40%"
            />
            <p class="confirm-content mb-2">
              Apakah Anda yakin untuk membatalkan pemeriksaan berikut?
            </p>
            <h4>{{ cancelItem.name }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btncancelItem"
              class="btn btn-danger"
              @click="
                () => {
                  confirmCancel(cancelItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-confirm" id="modalCall" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/doctor.svg"
              style="width: 40%"
            />
            <p class="confirm-content mb-2">Panggil pasien berikut ini?</p>
            <h4>{{ doctorCallItem.no_rm }} - {{ doctorCallItem.name }}</h4>
            <h5 v-if="doctorCallItem.formatted_no_antrian_dokter">
              No Antrian {{ doctorCallItem.formatted_no_antrian_dokter }}
            </h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btndoctorCallItem"
              class="btn btn-secondary"
              @click="
                () => {
                  confirmDoctorCall(doctorCallItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA, PANGGIL PASIEN
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import EmptyState from "@/components/EmptyState.vue";
// import { HTTP } from "@/config.js";
import {
  data,
  tabs,
  filters,
  filtersDoc,
  sort,
  sortDoc,
} from "@/data/Ralan.js";
import { updateFilter, getInputDate } from "@/data/helper.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "Ralan",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    Alert,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      cancelSuccess: false,
      cancelFailed: false,
      cancelItem: { id: null, name: "" },
      doctorCallSuccess: false,
      doctorCallFailed: false,
      doctorCallItem: { id: null, name: "" },
      loaded: false,
      avgTime: "",
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabs,
      created_from: getInputDate(),
      created_to: getInputDate(),
      orderBy: "asc",
      id_dokter: "",
      status: "DIJADWALKAN",
      darurat: 0,
      dirujuk: "SEMUA",
      columns: [
        // {
        //   label: "No",
        //   field: "number",
        // },
        { label: "Reg", field: "no_reg" },
        { label: "No Rawat", field: "no_rawat" },
        { label: "No", field: "formatted_no_antrian_dokter" },
        { label: "Tanggal", field: "tgl_periksa" },
        { label: "Jam", field: "jam_periksa" },
        { label: "Dokter", field: "dokter.nama" },
        {
          label: "No. RM",
          field: "no_rm",
          headerClass: "class-in-header second-class",
        },
        { label: "Pasien", field: "pasien.nama" },
        { label: "JK", field: "pasien.jen_kelamin" },
        { label: "Umur", field: "pasien.formatted_umur" },
        // { label: "Pembayaran", field: "pasien.asuransi.nama" },
        {
          label: "",
          class: "dropdown",
          representedAs: (data) => {
            let comp = "";
            //console.log(data);
            switch (data.status) {
              case "DIJADWALKAN":
                comp = `<a class="dropdown-item" data-toggle="modal" data-target="#modalCall" onclick="document.getElementById('doctorCall${data.id}').click()" >
                        <i class="material-symbols-outlined">mic</i>Panggil Pasien
                    </a><a class="dropdown-item" href="/#/ralan/form-petugas/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">streetview</i>Input Pemeriksaan Perawat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-ophthalmic/${data.id}?fromTab=${data.fromTab}" >
                        <i class="material-symbols-outlined">remove_red_eye</i>Input Pemeriksaan Ophthalmic
                    </a><!--a class="dropdown-item" href="/#/ralan/form-dokter/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">face</i>Input Pemeriksaan Dokter
                    </a-->
                    <a class="dropdown-item" data-toggle="modal" data-target="#modalDelete" onclick="document.getElementById('cancel${data.id}').click()" >
                        <i class="material-symbols-outlined">cancel</i>Batalkan Pemeriksaan
                    </a>`;
                break;
              case "ANTRIAN DOKTER":
                comp = `<a class="dropdown-item" href="/#/ralan/form-dokter/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">face</i>Input Pemeriksaan Dokter
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-petugas/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">streetview</i>Ubah Pemeriksaan Perawat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-ophthalmic/${data.id}?fromTab=${data.fromTab}" >
                        <i class="material-symbols-outlined">remove_red_eye</i>Ubah Pemeriksaan Ophthalmic
                    </a>
                    <a class="dropdown-item" data-toggle="modal" data-target="#modalDelete" onclick="document.getElementById('cancel${data.id}').click()" >
                        <i class="material-symbols-outlined">cancel</i>Batalkan Pemeriksaan
                    </a>`;
                break;
              case "SEDANG DIPERIKSA":
                comp = `<a class="dropdown-item" href="/#/ralan/form-petugas/edit/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">streetview</i>Ubah Pemeriksaan Perawat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-ophthalmic/edit/${data.id}?fromTab=${data.fromTab}" >
                        <i class="material-symbols-outlined">remove_red_eye</i>Ubah Pemeriksaan Ophthalmic
                    </a><a class="dropdown-item" href="/#/ralan/form-dokter/edit/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">face</i>Ubah Pemeriksaan Dokter
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-tindakan/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">add</i>Input Tindakan
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-obat/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">add</i>Input Resep Obat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-optik/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">add</i>Input Resep Optik
                    </a>
                    <!--a-- class="dropdown-item" href="/#/ralan/form-/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">add</i>
                    </!--a-->
                    <!--a-- class="dropdown-item" v-on:click="()=>{cancel(${data.id})}" >
                        <i class="material-symbols-outlined"></i>Pemeriksaan Selesai
                    </!--a-->
                    `;
                break;
              case "SELESAI DIPERIKSA":
                comp = `<a class="dropdown-item" href="/#/ralan/form-petugas/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">streetview</i>Ubah Pemeriksaan Perawat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-ophthalmic/${data.id}?fromTab=${data.fromTab}" >
                        <i class="material-symbols-outlined">remove_red_eye</i>Ubah Pemeriksaan Ophthalmic
                    </a><a class="dropdown-item" href="/#/ralan/form-dokter/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">face</i>Ubah Pemeriksaan Dokter
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-tindakan/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah Tindakan
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-obat/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah Resep Obat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-optik/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah Resep Optik
                    </a>
                    <a class="dropdown-item" target="_blank" href="/#/ralan/cetak-kajian-medis/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">print</i>Cetak Kajian Medis
                    </a>
                    <a class="dropdown-item" target="_blank" href="/#/ralan/cetak-resep-obat/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">print</i>Cetak Resep Obat
                    </a>
                    <a class="dropdown-item" target="_blank" href="/#/ralan/cetak-resep-optik/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">print</i>Cetak Resep Optik
                    </a>
                    <!--a-- class="dropdown-item" href="/#/ralan/form-/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah
                    </!--a-->
                    <!--a-- class="dropdown-item" v-on:click="()=>{cancel(${data.id})}" >
                        <i class="material-symbols-outlined"></i>Pemeriksaan Selesai
                    </!--a-->
                    `;
                break;
              case "MENUNGGU PEMBAYARAN":
                comp = `<a class="dropdown-item" href="/#/ralan/form-petugas/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">streetview</i>Ubah Pemeriksaan Perawat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-ophthalmic/${data.id}?fromTab=${data.fromTab}" >
                        <i class="material-symbols-outlined">remove_red_eye</i>Ubah Pemeriksaan Ophthalmic
                    </a><a class="dropdown-item" href="/#/ralan/form-dokter/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">face</i>Ubah Pemeriksaan Dokter
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-tindakan/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah Tindakan
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-obat/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah Resep Obat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-optik/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah Resep Optik
                    </a>
                    <a class="dropdown-item" target="_blank" href="/#/ralan/cetak-kajian-medis/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">print</i>Cetak Kajian Medis
                    </a>
                    <a class="dropdown-item" target="_blank" href="/#/ralan/cetak-resep-obat/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">print</i>Cetak Resep Obat
                    </a>
                    <a class="dropdown-item" target="_blank" href="/#/ralan/cetak-resep-optik/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">print</i>Cetak Resep Optik
                    </a>
                    <!--a-- class="dropdown-item" href="/#/ralan/form-/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah
                    </!--a-->
                    <!--a-- class="dropdown-item" v-on:click="()=>{cancel(${data.id})}" >
                        <i class="material-symbols-outlined"></i>Pemeriksaan Selesai
                    </!--a-->
                    `;
                break;
              case "SELESAI":
                comp = `<a class="dropdown-item" href="/#/ralan/form-petugas/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">streetview</i>Ubah Pemeriksaan Perawat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-ophthalmic/${data.id}?fromTab=${data.fromTab}" >
                        <i class="material-symbols-outlined">remove_red_eye</i>Ubah Pemeriksaan Ophthalmic
                    </a><a class="dropdown-item" href="/#/ralan/form-dokter/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">face</i>Ubah Pemeriksaan Dokter
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-tindakan/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah Tindakan
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-obat/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah Resep Obat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-optik/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah Resep Optik
                    </a>
                    <a class="dropdown-item" target="_blank" href="/#/ralan/cetak-kajian-medis/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">print</i>Cetak Kajian Medis
                    </a>
                    <a class="dropdown-item" target="_blank" href="/#/ralan/cetak-resep-obat/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">print</i>Cetak Resep Obat
                    </a>
                    <a class="dropdown-item" target="_blank" href="/#/ralan/cetak-resep-optik/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">print</i>Cetak Resep Optik
                    </a>
                    <!--a-- class="dropdown-item" href="/#/ralan/form-/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>Ubah
                    </!--a-->
                    <!--a-- class="dropdown-item" v-on:click="()=>{cancel(${data.id})}" >
                        <i class="material-symbols-outlined"></i>Pemeriksaan Selesai
                    </!--a-->
                    `;
                break;
              case "DIBATALKAN":
                comp = ``;
                break;
              default:
                comp = `<a class="dropdown-item" href="/#/ralan/form-petugas/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">streetview</i>Input Pemeriksaan Perawat
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form-ophthalmic/${data.id}?fromTab=${data.fromTab}" >
                        <i class="material-symbols-outlined">remove_red_eye</i>Input Pemeriksaan Ophthalmic
                    </a><a class="dropdown-item" href="/#/ralan/form-dokter/${data.id}?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">face</i>Input Pemeriksaan Dokter
                    </a>
                    <!--a-- class="dropdown-item" v-on:click="()=>{cancel(${data.id})}" >
                        <i class="material-symbols-outlined"></i>Batalkan Pemeriksaan
                    </!--a-->`;
            }
            return `
            ${
              data.status == "DIJADWALKAN"
                ? `
                <a class="btn btn-sm btn-secondary btn-icon" data-toggle="modal" data-target="#modalCall" onclick="document.getElementById('doctorCall${data.id}').click()"><i class="material-symbols-outlined">mic</i></a>
                `
                : `
            `
            }
            <a class="btn btn-sm btn-success btn-icon" href="/#/ralan/detail/${
              data.id
            }?fromTab=${
              data.fromTab
            }"><i class="material-symbols-outlined">open_in_new</i></a>
                <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
                    <i class="material-symbols-outlined">apps</i>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
                    <a class="dropdown-item" href="/#/ralan/detail/${
                      data.id
                    }?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">open_in_new</i>
                        Detail Rawat Jalan
                    </a>
                    <a class="dropdown-item" href="/#/ralan/cetak-kartu/${
                      data.id
                    }?fromTab=${data.fromTab}" target="_blank">
                        <i class="material-symbols-outlined">content_paste</i>
                        Cetak Kartu Rawat Jalan
                    </a>
                    <a class="dropdown-item" href="/#/ranap/form/${data.id}/0" >
                        <i class="material-symbols-outlined">local_hotel</i>
                        Daftarkan Rawat Inap
                    </a>
                    <a class="dropdown-item" href="/#/ralan/form/edit/${
                      data.id
                    }?fromTab=${data.fromTab}">
                        <i class="material-symbols-outlined">create</i>
                        Ubah Data Awal
                    </a>
                    ${comp}
                </div>`;
          },
          interpolate: true,
        },
        // {label: 'Address', representedAs: ({address, city, state}) => `${address}<br />${city}, ${state}`, interpolate: true}
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      totalData: 0,
      rows: [],
      synth: window.speechSynthesis,
      voiceList: [],
      greetingSpeech: new window.SpeechSynthesisUtterance(),
    };
  },
  methods: {
    async filterTab(filter) {
      // ////console.log(filter);
      this["status"] = filter;
      await this.displayList();
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      await this.displayList();
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      this.data.actionBtn[0].link = `${this.plainUrl}?fromTab=${this.status}`;
      try {
        let params = `?per_page=${this.perPage}&page=${this.page}&darurat=0`;
        //console.log(this.status);
        if (this["filter"]) {
          params += `&cari_rawat=${this.filter}`;
        }
        if (this.status) {
          params += `&status=${this.status}`;
        }

        // created from and created to filter
        if (this.created_from) {
          params += `&created_from=${this.created_from}`;
        } else {
          params += `&created_from=null`;
        }
        if (this.created_to) {
          params += `&created_to=${this.created_to}`;
        } else {
          params += `&created_to=null`;
        }
        // created from and created to filter

        if (this.dirujuk != "SEMUA") {
          params += `&dirujuk=${this.dirujuk}`;
        }
        if (this.id_dokter) {
          params += `&id_dokter=${this.id_dokter}`;
        }
        if (this.$store.state.role == "dokter" && this.$store.state.id_dokter) {
          if (this.orderBy) {
            params += `&orderBy=${this.orderBy}&orderColumn=no_antrian_dokter`;
          } else {
            params += `&orderBy=asc&orderColumn=no_antrian_dokter`;
          }
        } else {
          if (this.orderBy) {
            params += `&orderBy=${this.orderBy}&orderColumn=no_rawat`;
          } else {
            params += `&orderBy=asc&orderColumn=no_rawat`;
          }
        }
        let result = await this.$store.state.HTTP.get(`ralan${params}`);
        //console.log(`ralan${params}`)
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          //console.log("berhasil");
          this.rows = result.data.data.map((item, index) => {
            item.number =
              ((self.page || 1) - 1) * (self.perPage || 10) + index + 1;
            item.fromTab = self.status;
            return item;
          });
          //console.log(this.rows);
          this.totalData = result.data.total;
          // //console.log(this.totalData);
          this.loaded = true;
          if (this.rows && this.rows.length) {
            // this.$nextTick(() => {
            //   if (this.$refs.focusMe) {
            //     this.$refs.focusMe.focus();
            //   }
            // });
          }

          //console.log(this.rows);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        //console.log(result);
        if (result.status == "200") {
          let doctors = result.data.data;
          this.filters.columns[2].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          if (
            this.$store.state.role == "dokter" &&
            this.$store.state.id_dokter &&
            this.$store.state.id_dokter != "null"
          ) {
            this.id_dokter = this.$store.state.id_dokter;
            ////console.log(this.id_dokter)
            updateFilter(this, this.filters, false, this.handleChange);
          }
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    cancel: async function(id, name) {
      this.cancelItem = {
        id: id,
        name: name,
      };
    },

    async confirmCancel(id) {
      //console.log(id);
      let result = await this.$store.state.HTTP.put(
        `ralan/${id}`,
        `status=DIBATALKAN`
      );
      //console.log(result);
      if (result.status == 200) {
        this.cancelSuccess = true;
        await this.displayList();
      } else {
        this.cancelFailed = true;
      }
      this.resetAlert();
    },

    doctorCall: async function(
      id,
      name,
      no_rawat,
      no_rm,
      dokter,
      formatted_no_antrian_dokter
    ) {
      this.doctorCallItem = {
        id: id,
        name: name,
        no_rawat: no_rawat,
        no_rm: no_rm,
        dokter: dokter,
        formatted_no_antrian_dokter: formatted_no_antrian_dokter,
      };
    },

    async confirmDoctorCall(id) {
      //console.log(id);
      let result = await this.$store.state.HTTP.put(
        `ralan/${id}`,
        `status=ANTRIAN DOKTER`
      );
      //console.log(result);
      if (result.status == 200) {
        this.doctorCallSuccess = true;
        // this.greetingSpeech.text = `Pasien ${this.doctorCallItem.name} dengan nomor rekam medis ${this.doctorCallItem.no_rm} silakan menuju ke ruangan dokter ${this.doctorCallItem.dokter}`;
        this.greetingSpeech.text = `Pasien ${this.doctorCallItem.name} dengan nomor antrian ${this.doctorCallItem.formatted_no_antrian_dokter} silakan menuju ke ruangan ${this.doctorCallItem.dokter}`;
        //   56 adalah bahasa indonesia
        //   6 adalah bahasa indonesia
        //   41 adalah bahasa inggris
        //   versi lain:
        //   11 adalah bahasa indonesia
        this.greetingSpeech.voice = this.voiceList[11];
        this.synth.speak(this.greetingSpeech);
        await this.displayList();
      } else {
        this.doctorCallFailed = true;
      }
      this.resetAlert();
    },

    async getStat() {
      let result = await this.$store.state.HTTP.get(
        "ralan/waktu_tunggu_average"
      );
      //console.log(result);
      //console.log(JSON.stringify(result));
      if (result.status == "200") {
        //console.log("berhasil");
        //console.log(result.data);
        // this.avgTime = `10 jam 59 menit 59 detik`
        this.avgTime = `${
          result.data.diffInHours ? result.data.diffInHours + " jam " : ""
        }${
          result.data.diffInMinutes ? result.data.diffInMinutes + " menit " : ""
        }${
          result.data.diffInSeconds ? result.data.diffInSeconds + " detik" : ""
        }`;
      } else {
        this.avgTiem = `Tidak ada data`;
      }
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.cancelSuccess = false;
        self.cancelFailed = false;
        self.doctorCallSuccess = false;
        self.doctorCallFailed = false;
      }, 5000);
    },
    async goToPage(e) {
      // //console.log(e.target.innerHTML);
      let trg = e.target;
      // //console.log(trg);
      let char = trg.innerHTML;
      let disabled = trg.classList.contains("disabled");
      if (!disabled) {
        if (["‹", "›"].indexOf(char) < 0) {
          this.page = parseInt(char);
        }
      }
      await this.displayList();
    },
  },
  watch: {
    async perPage(newData, oldData) {
      if (newData != oldData) {
        this.page = 1;
        await this.displayList();
      }
    },
    async filter(newData, oldData) {
      if (newData != oldData) {
        this.page = 1;
        await this.displayList();
      }
    },
    // page(newData,oldData){
    //   // if(newData!=oldData){
    //   await this.displayList();
    //   // }
    // }
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.voiceList = this.synth.getVoices();
    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices();
    };
    this.plainUrl = this.data.actionBtn[0].link.split("?")[0];

    if (this.$store.state.role == "dokter") {
      // this.filterTab('SEDANG DIPERIKSA');
      this.status = "ANTRIAN DOKTER";
      this.id_dokter = this.$store.state.id_dokter;
      this.sort = sortDoc;
      this.filters = filtersDoc;
    }
    if (this.$route.query.tab) {
      this.status = this.$route.query.tab;
    }

    this.fetchDoctors();
    await this.displayList();
    this.getStat();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
